<template>
  <div class="container">
    <div class="row">
      <div class="col-7 d-flex align-items-center">
        <span class="statement-value">{{ label }}</span>
      </div>
      <div class="col-5 d-flex align-items-center justify-content-start">
        <div v-if="isComputed">{{ value }}</div>
        <FormInputAmountWidget v-else class="flex-grow-1" :value="value" :min="0" @input="$emit('input', $event)" :label="label" hideLabel />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    label: {
      type: String,
    },
    value: {
      type: Number,
      required: false,
      default: null,
    },
    isComputed: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
  },
};

</script>

<style lang="scss"></style>
